import { ExchangeRates } from '@qvs/core';
import { createLoadingStatusActionGroupWithResponse } from '~/shared/helpers/loading-status-helper';

const prefix = '[ExchangeRates]';

export const {
  load: loadExchangeRates,
  success: loadExchangeRatesSuccess,
  failure: loadExchangeRatesFailure
} = createLoadingStatusActionGroupWithResponse<{ exchangeRates: ExchangeRates }>(prefix, 'exchange rates');
